import React, { useState, useEffect, useContext, useMemo } from "react";
import { LocalesProvider, LocalesContext } from "./contexts/LocalesContext";
import SectionContentComponent from "./components/SectionContentComponent";
import SectionContentBlockComponent from "./components/SectionContentBlockComponent";
import IrriappResumeComponent from "./irriapp/components/ConfResumeComponent";
import MiplusResumeComponent from "./miplus/components/ConfResumeComponent";
import Miplus2ResumeComponent from "./miplus2/components/ConfResumeComponent";
import { getMachineParamsValue } from "./utils/irriapp";

function SessionPresets(props) {
  const { session } = props;
  const unitsSystem = props.units_system;
  const deviceType = props.session_type || 'irriapp';
  const dataJsonUrl = props.data_json_url;
  
  const [miplus2Data, setMiplus2Data] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const {
    t,
    translations,
    actions: localesActions,
  } = useContext(LocalesContext);

  // MEMOS ******************************************************************

  const configuration = useMemo(() => {
    if (deviceType === 'irriapp') {
      const c = {};
      Object.keys(props.session.params).forEach((key) => {
        if (!key.startsWith("program_")) return;
        c[key.replace("program_", "")] = getMachineParamsValue(
          props.session.params,
          key
        );
      });
      return c;

    } else if (deviceType === 'miplus') {
      return props.session?.params?.logPreset;

    } else if (deviceType === 'miplus2') {
      if (miplus2Data?.presets) {
        // Prende il primo dispositivo dai presets_original
        const firstDevice = Object.values(miplus2Data.presets)[0];
        if (firstDevice?.newJson?.preset) {
          return {
            ...firstDevice.newJson.preset,
            meta: firstDevice.meta
          };
        }
      }
      return {};
    }
    return {};
  }, [props.session, deviceType, miplus2Data]);

  // EFFECTS ******************************************************************

  useEffect(() => {
    localesActions.setLocale(props.locale);
    localesActions.setTranslations(props.translations);
  }, []);

  useEffect(() => {
    if (deviceType === 'miplus2' && dataJsonUrl && !miplus2Data) {
      setLoading(true);
      fetch(dataJsonUrl)
        .then(response => response.json())
        .then(data => {
          setMiplus2Data(data);
          setLoading(false);
        })
        .catch(error => {
          console.error('Errore nel caricamento dei dati JSON:', error);
          setLoading(false);
        });
    }
  }, [deviceType, dataJsonUrl, miplus2Data]);

  // RENDER ******************************************************************

  if (deviceType === 'miplus2') {
    if (loading) {
      return (
        <SectionContentComponent>
          <SectionContentBlockComponent sizes={{ default: 24 }}>
              <div className="c-message">
                <div className="c-message__content c-message__content--small">
                  Caricamento dati preset...
                </div>
              </div>
          </SectionContentBlockComponent>
        </SectionContentComponent>
      );
    }

    if (!miplus2Data) {
      return (
        <SectionContentComponent>
          <SectionContentBlockComponent sizes={{ default: 24 }}>
              <div className="c-message">
                <div className="c-message__content c-message__content--small">
                  Dati preset non disponibili
                </div>
              </div>
          </SectionContentBlockComponent>
        </SectionContentComponent>
      );
    }

    return (
        <SectionContentComponent>
          <SectionContentBlockComponent sizes={{ default: 24, md: 10 }}>
              <Miplus2ResumeComponent 
                configuration={configuration} 
                unitsSystem={unitsSystem}
              />
          </SectionContentBlockComponent>
        </SectionContentComponent>
    );
  }

  if (deviceType === 'miplus') {
    return (
      <SectionContentComponent>
        <SectionContentBlockComponent sizes={{ default: 24, md: 10 }}>
            <MiplusResumeComponent 
              configuration={configuration} 
              unitsSystem={unitsSystem}
            />
        </SectionContentBlockComponent>
      </SectionContentComponent>
    );
  }

  return (
    <SectionContentComponent>
      <SectionContentBlockComponent sizes={{ default: 24, md: 10 }}>
          <IrriappResumeComponent 
            configuration={configuration} 
            unitsSystem={unitsSystem}
          />
      </SectionContentBlockComponent>
    </SectionContentComponent>
  );
}

export default (props) => {
  return (
    <LocalesProvider>
      <SessionPresets {...props} />
    </LocalesProvider>
  );
};